import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React from "react";

const ParallaxPage = () => {
  const sections = [
    {
      title: "السباحة الحرة: الأسلوب، التقنية، وأهمية كل حركة",
      content: `
        تُعد السباحة الحرة الأسرع بين الأنماط الأربعة للسباحة، ويعتمد أسلوبها على المسافة التي يسعى السباح إلى قطعها. 
        تختلف طريقة سباحة 50 و100 متر عن السباحة لمسافات أطول مثل 200 و400 متر، وحتى 1500 متر أو المسافات الطويلة 
        في المياه المفتوحة. كلما زادت المسافة، تغيرت التقنية وأصبحت أكثر تكيفاً مع المتطلبات البدنية والتحمل.
      `,
      image: "/images/swimming-types/free/CVRY2622.jpg",
    },
    {
      title: "مميزات السباحة الحرة وتفاصيل تعليمها",
      content: `
        من وجهة نظري، تعد السباحة الحرة من أسهل الأساليب للتعليم، فهي سلسة وبسيطة. 
        في البداية، قد تجد بعض النساء صعوبة في تعلمها، لكن مع التدريب المستمر، التكرار، 
        وفهم آلية الحركة، يمكن تحقيق التقدم. يجب ألا يعتمد المتعلمون فقط على التقليد، 
        بل يتطلب تعلم السباحة الحرة التركيز على ثلاثة عناصر أساسية: 
        التعلم بطريقة صحيحة، التدريب المستمر، ومتابعة الفيديوهات التعليمية المناسبة التي تشرح الحركات بوضوح.
      `,
      image: "/images/swimming-types/free/ERED2027.jpg",
    },
    {
      title: "النقاط الأساسية لتعلم السباحة الحرة: وضعية الجسم",
      content: `
        يتعين على الجسم أن يكون موازياً لسطح الماء ومستقيماً، بحيث ينظر الرأس للأسفل. 
        إن البدء من وضعية سليمة يقلل من المقاومة خلال السباحة ويقلل من آلام المفاصل والضغط على العمود الفقري. 
        هذه الوضعية هي الأساس في جميع أنواع السباحة، كما أنها تمنح الثقة وتحسن التوازن في الماء.
        
        من المهم أن نفهم أن التوازن الجسدي في الماء لا يكتمل إلا عند تحقيق توافق بين 
        الثقة بالنفس والمشاعر والجسد، فهذه العناصر هي الأساس في تعلم السباحة.
      `,
      image: "/images/swimming-types/free/BZYM3280.jpg",
    },
    {
      title: "النقاط الأساسية لتعلم السباحة الحرة: حركة اليدين",
      content: `
        الاعتماد الأكبر في السباحة الحرة يكون على حركة اليدين، خاصةً في المسافات الطويلة. 
        يمكن تحسين السرعة والقدرة على السباحة لمسافات أطول عبر تحسين عملية الجرف (التجديف) في الماء. 
        في التسعينات، تغيّرت معايير حركة اليدين مع السباح الروسي ألكسندر بوبوف، 
        ومن بعده الأمريكي مايكل فيلبس، مما أثر بشكل كبير في تقنيات السباحة الحرة.
        
        النقاط المهمة في حركة اليدين:
        - إخراج اليد: بعد الانتهاء من الدفع بالكامل، يتم إخراج اليد بحيث يكون المرفق مستقيماً بزاوية 180 درجة بجانب الفخذ.
        - زاوية الرفع: تُرفع اليد بزاوية مائلة نحو سطح الماء مع توجيه الكف للخارج. 
        - استعداد اليد للدخول: بعد إخراج اليد، يجب إعدادها للدخول مرة أخرى إلى الماء 
          بتوجيه الساعد والكف للأمام، بحيث يدخل الإصبع الأوسط أولاً وبزاوية مباشرة نحو الكتف.
      `,
      image: "/images/swimming-types/free/IMG_9010.jpg",
    },
    {
      title: "النقاط الأساسية لتعلم السباحة الحرة: حركة الرجلين",
      content: `
        تعتبر حركة الرجلين مسؤولة عن 25% من الجهد في السباحة الحرة، وتساهم بشكل رئيسي 
        في تحقيق توازن الجسم. تختلف وتيرة وسرعة حركة الرجلين حسب المسافة، 
        حيث تقل حركة الرجلين مع زيادة المسافة للحفاظ على الطاقة.
        
        أخطاء شائعة في حركة الرجلين وكيفية تجنبها:
        - حركة الرجلين من الركبة بدلاً من الفخذ: يسبب هذا جهدًا إضافيًا وتباطؤًا في السباحة.
        - عدم التناسق بين الحركات: يجب تحقيق تناغم بين حركات الرجلين لضمان تقدم سلس في الماء.
        - استخدام القوة الزائدة: يزيد من التعب ويؤثر على القدرة على الاستمرار في السباحة.
      `,
      image: "/images/swimming-types/free/ASQO4696.jpg",
    },
    {
      title: "النقاط الأساسية لتعلم السباحة الحرة: عملية التنفس",
      content: `
        تُعدّ التنفس الصحيح أحد أسرار السباحة الحرة، ومن أهم التحديات للسباحين، 
        إذ تخرج الرأس للتنفس مما يخلّ بتوازن الجسم. إن التنفس بطريقة صحيحة يوفر 
        الأمان، الثقة، والقدرة على السباحة لمسافات طويلة بسلاسة.
        
        الحل: أنصح بالعمل مع مدرب سباحة متخصص، أو باستخدام الشنوكل لتسهيل عملية التنفس 
        أثناء التدريب. هناك أيضًا تمارين خاصة لتحسين مهارة التنفس.
      `,
      image: "/images/swimming-types/free/CXAQ5635.jpg",
    },
    {
      title: "تحسين الأداء وكسب الثقة",
      content: `
        لاحظت من خلال تدريبي للنساء أن الثقة في المدرب، والتواصل الواضح، 
        والدقة في الشرح، جميعها عوامل تسهم في تطوير مهارات السباحة. 
        يجب على المدربين تعديل طريقة الشرح حسب احتياجات كل سباحة، 
        مما يعزز من عملية التعليم ويدعم تحقيق نتائج أفضل.
      `,
      image: "/images/swimming-types/free/BLXQ7723.jpg",
    },
  ];

  return (
    <>
    <div className="font-sans">
      
         {/* <div
            className="h-[50vh]"
          >
                   <video
          className="absolute top-0 left-0 w-full h-full object-cover"
          src="/videos/HRLS9991.mp4"
          autoPlay
          muted
          loop
        ></video>

          </div> */}
      {sections.map((section, index) => (
        <React.Fragment key={index}>

          {/* Content Section */}
          <section
            className={`py-16 px-8 bg-opacity-20 text-center ${
              index % 2 === 0 ? "bg-blueGray-200 " : "bg-gray-100"
            }`}
          >
            
            <h2 className="text-4xl font-semibold mb-4">{section.title}</h2>
            <p className="text-lg leading-8 whitespace-pre-line">{section.content}</p>
          </section>
                    {/* Parallax Image */}
                    <div
            className="h-[50vh] bg-fixed bg-center bg-cover"
            style={{ backgroundImage: `url(${section.image})` }}
          ></div>
   
        </React.Fragment>
      ))}

      {/* Footer */}
      <Footer />

    </div>
    </>

  );
};

export default ParallaxPage;
